import { Alert, Button, DialogActions, Slide, Snackbar } from "@mui/material";
import { createContext, useContext, useState } from "react";
import Utils from "../Utils";
import { CheckCircleOutline } from "@mui/icons-material";

type TSeverity = "error"|"warning"|"info"|"success";

export interface ISnackbar {
    severity:TSeverity,
    title:string,
    message:string|null|undefined,
    duration:number,
    actions?:JSX.Element[]
}
export type TSetSnackbar = (title:string|any, message?:string|null|undefined, severity?:TSeverity, duration?:number)=>void;

interface ISnackbarContext {
    snackbar:ISnackbar|null,
    setSnackbar:TSetSnackbar;
}
const SnackbarContext = createContext<ISnackbarContext>({snackbar:null,setSnackbar:()=>{}})

export const useSnackbar = () => useContext(SnackbarContext)

export default function SnackbarProvider(props:any){
    const [snackbar,_setSnackbar] = useState<ISnackbar|null>(null)
    const onClose = () => _setSnackbar(null)
    const setSnackbar = (title:string|any, message:string|null|undefined, severity:TSeverity="error", duration:number|undefined=undefined, actions?:JSX.Element[]) => {
        if (typeof(duration)=="undefined") {
            if (severity=="error") duration = 5000
            else duration = 2000
        }
        if (severity=="error"){
            if (!actions) actions = []
            actions.push(<Button key="close" variant="contained" color="secondary" onClick={onClose}>OK, Thanks!</Button>)
        }
        if (title instanceof Object) _setSnackbar({severity,duration,...Utils.errorMsg(title),actions})
        else _setSnackbar({severity, title, message, duration, actions})
    }
    const _snackbar = snackbar ? <SnackbarContent snackbar={snackbar} onClose={onClose}/> : null
    return <SnackbarContext.Provider value={{snackbar,setSnackbar}}>
        {props.children}
        {_snackbar}        
    </SnackbarContext.Provider>
}

function SnackbarContent(props:{snackbar:ISnackbar,onClose:()=>void}){
    const {snackbar} = props
    const actions = snackbar.actions ? <DialogActions>{snackbar.actions}</DialogActions> : null
    const klass = "body s_" + snackbar.severity
    return <Snackbar open={true} autoHideDuration={snackbar.duration} onClose={props.onClose} 
        anchorOrigin={ {vertical : "top", horizontal: "center"} } 
        TransitionComponent={Slide}>
        <div className={klass}><div>
            <CheckCircleOutline/>
            {snackbar.title ? <div className="title">{snackbar.title}</div> : null}
            {snackbar.message ? <div className="msg">{snackbar.message}</div> : null}
            {actions}
        </div></div>
    </Snackbar>
}